var styles = {"wrapper":"CardBrandImage-module_wrapper__dg5Cw"};

export { styles as default };
//# sourceMappingURL=CardBrandImage.module.scss.js.map
